export default "__VITE_ASSET__CgS4R79t__"